import React from 'react';
import { CheckSquare, AlertTriangle, Calendar, MessageSquare } from 'lucide-react';
import './EventTypeFilter.scss';

const EVENT_TYPES = [
  { id: 2, label: 'Tasks', icon: CheckSquare },
  { id: 3, label: 'Risks', icon: AlertTriangle },
  { id: 4, label: 'Meetings', icon: Calendar },
  { id: 5, label: 'Communications', icon: MessageSquare }
];

export const EventTypeFilter = ({ events, selectedTypes, onFilterChange }) => {
  const getEventCount = (typeId) => {
    return events.filter(event => event.type === typeId).length;
  };

  const handleToggleType = (typeId) => {
    const newSelectedTypes = selectedTypes.includes(typeId)
      ? selectedTypes.filter(id => id !== typeId)
      : [...selectedTypes, typeId];
    
    onFilterChange(newSelectedTypes);
  };

  return (
    <div className="event-type-filter">
      {EVENT_TYPES.map(({ id, label, icon: Icon }) => {
        const count = getEventCount(id);
        const isSelected = selectedTypes.includes(id);
        
        return (
          <button
            key={id}
            data-type={id}
            className={`event-type-filter__button ${isSelected ? 'event-type-filter__button--active' : ''}`}
            onClick={() => handleToggleType(id)}
            title={label}
            disabled={count === 0}
          >
            <Icon className="event-type-filter__icon" />
            {count > 0 && (
              <span className="event-type-filter__count">{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};
